import React from 'react';
import {useTranslation} from 'react-i18next';

import {Button, BUTTON_VARIANTS, Typography} from '@nur-portal/ui-kit';

import styles from '../authenticated-overlay.module.css';

const StepNoNickname = ({
  goNext
}) => {
  const {t} = useTranslation('authOverlay');

  return (
    <>
      <Typography variant='title-16' className={styles.title}>
        {t('titleNickname')}
      </Typography>
      <Typography variant='text-14' className={styles.content}>
        {t('description.noNickname')}
      </Typography>
      <div className={styles.actionButtons}>
        <Button
          variant={BUTTON_VARIANTS.PRIMARY}
          onClick={goNext}
          className={styles.actionButton}
        >
          {t('buttons.set')}
        </Button>
      </div>
    </>
  );
};

export {StepNoNickname};
